export default "__VITE_ASSET__Bd1Eh4jX__"